<template>
  <div class="animated fadeIn">
  <b-row>
    <b-col cols="12" lg="12">
      <b-card class="w-100" no-header>
        <template slot="header">
          <span class="mt-2">Insurer : {{ details.code }} {{ details.name }}</span>
          <b-button @click="goBack" class="btn-sm pull-right">Back</b-button>
        </template>


        <div id="error" class="card border-danger" v-show="error">
          <div class="card-header bg-danger border-danger">

              <span class="text-white font-weight-bolder">
              <i class="fa fa-exclamation-triangle"></i>
               &nbsp;
              {{ error_heading }}
              </span>

          </div>
          <div class="card-body border-danger text-dark font-weight-bold">

            {{ error_text }}

          </div>
        </div>

        <div>

          <b-form-row class="mb-3">

            <b-col cols="3">
              <label class="">Code</label>
              <b-input v-model="$v.details.code.$model" class="mb-2 mr-sm-2 mb-sm-0" :state="validateState('code')"></b-input>
              <b-form-invalid-feedback v-if="!$v.details.code.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

            <b-col cols="4">
              <label class="">Short name</label>
              <b-input v-model="$v.details.short_name.$model" class="mb-2 mr-sm-2 mb-sm-0"  :state="validateState('short_name')"></b-input>
              <b-form-invalid-feedback v-if="!$v.details.short_name.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

            <b-col cols="5">
              <label class="">Name</label>
              <b-input v-model="$v.details.name.$model" class="mb-2 mr-sm-2 mb-sm-0"  :state="validateState('name')"></b-input>
              <b-form-invalid-feedback v-if="!$v.details.name.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

          </b-form-row>

          <b-form-row class="mb-3">

            <b-col cols="12">
              <label class="">Full Name</label>
              <b-input v-model="$v.details.full_name.$model" class="mb-2 mr-sm-2 mb-sm-0" :state="validateState('full_name')"></b-input>
              <b-form-invalid-feedback v-if="!$v.details.full_name.required">This is a required field.</b-form-invalid-feedback>
            </b-col>
          </b-form-row>

          <b-form-row class="mb-3">
            <b-col cols="12">
              <label :class=" !$v.details.regulatory_text.required ? 'text-danger' : 'light-theme'">Regulatory Text</label>
              <editor v-model="details.regulatory_text" :options="editorOption" :toolbar="toolbarOptions"></editor>
              <b-form-invalid-feedback v-if="!$v.details.regulatory_text.required">This is a required field.</b-form-invalid-feedback>
              <p v-if="!$v.details.regulatory_text.required" class="text-danger small mt-2">This is a required field</p>
            </b-col>
          </b-form-row>

        </div>

        <b-form-row>

            <b-col cols="4">
              <label class="">Discount Enabled</label>
              <b-form-select v-model="$v.details.discount_enabled.$model" :options="options.yes_no" :state="validateState('discount_enabled')"></b-form-select>
              <b-form-invalid-feedback v-if="!$v.details.discount_enabled.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

            <b-col cols="4">
              <label class="">Direct Debit Enabled</label>
              <b-form-select v-model="$v.details.direct_debit_enabled.$model" :options="options.yes_no" :state="validateState('direct_debit_enabled')"></b-form-select>
              <b-form-invalid-feedback v-if="!$v.details.direct_debit_enabled.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

            <b-col cols="4">
              <label class="">Active</label>
              <b-form-select v-model="$v.details.active.$model" :options="options.yes_no" :state="validateState('active')"></b-form-select>
              <b-form-invalid-feedback v-if="!$v.details.active.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

        </b-form-row>

        <template slot="footer">
          <b-button @click="goBack" class="float-left">Back</b-button>
          <b-button variant="success" @click="editInsurer" class="float-right">Edit Insurer</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>

  </div>

</template>

<script>
  import axios from '../../../shared/axios/auth-no-loader'
  import Id from "bootstrap-vue/src/mixins/id";
  import { validationMixin } from 'vuelidate'
  import { required } from "vuelidate/lib/validators";
  import VueQuillEditor from 'vue-quill-editor'

  // require styles
  import 'quill/dist/quill.snow.css'

  var toolbarOptions = [
    ["bold","italic","underline",],
    [{list:"ordered"},{list:"bullet"}],
    [{header:1},{header:2},{header:3}],
    [{header:[1,2,3,4,5,6,!1]}]
  ]

  export default {
    name: 'EndorsementEdit',
    components: {
      Id,
      editor: VueQuillEditor.quillEditor
    },
    mixin: [validationMixin],
    props: {
      caption: {
        type: String,
        default: 'Edit'
      },
    },
    data: () => {
      return {
        details: {
          id: "",
          code: "",
          short_name: "",
          name: "",
          full_name: "",
          regulatory_text: "",
          discount_enabled: "",
          direct_debit_enabled: "",
          active: ""
        },
        toolbarOptions: toolbarOptions,
        editorOption: {
          theme: 'snow',
          modules: {
            toolbar: toolbarOptions
          },
        },
        error: false,
        error_heading: '',
        error_text: '',
        server_errors: {
          code: null,
          short_name: null,
          name: null,
          full_name: null,
          regulatory_text: null,
          discount_enabled: null,
          direct_debit_enabled: null,
          active: null
        },
        options: {
          yes_no: [
            {
              value: "",
              text: 'Please select'
            },
            {
              value: true,
              text: 'Yes'
            },
            {
              value: false,
              text: 'No'
            }
          ]
        }
      }
    },
    validations() {

      return {
        details: {
          code: {
            required
          },
          short_name: {
            required
          },
          name: {
            required
          },
          full_name: {
            required
          },
          regulatory_text: {
            required
          },
          discount_enabled: {
            required
          },
          direct_debit_enabled: {
            required
          },
          active: {
            required
          }
        }
      }

    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      validateState(name) {

        if (this.$v.details[name]) {
          const {$dirty, $error} = this.$v.details[name];
          return $dirty ? !$error : null;
        }
      },
      resetServerError(name) {

        if (this.server_errors[name]) {
          this.server_errors[name] = null;
        }

      },
      getInsurer() {
        let url = '';

        url = '/insurers/' + this.$route.params.insurer + '/?product=' + this.$route.params.product

        axios.get(url).then(
          response => {
            this.details = response.data;
            this.options.insurers = response.data.insurers;
          }
        ).catch(error => {

            // Unauthorised
            if (error.response.status === 401) {
              this.$store.dispatch('logout');
            }

            console.log('premium error');
            console.log(error.response)
          })
      },
      editInsurer() {

        this.error = false;

        this.$v.$touch();

        if(this.$v.$anyError) {

          window.scrollTo(document.querySelector('#error').offsetTop, 100);
          this.error = true;
          this.error_heading = 'There are errors on the form';
          this.error_text = 'Please fix the errors and re-submit the form';
          return

        } else {

          const post_data = JSON.parse(JSON.stringify(this.details));

          let url = '';

          url = '/insurers/' + this.$route.params.insurer + '/?product=' + this.$route.params.product;

          axios.put(url, post_data).then(
            response => (
              this.data = response.data
            )
          ).then(response => {
            response

            let alert = {
              type: 'success',
              text: 'Insurer : ' + this.details.short_name + ' ' + this.details.name + ' was updated successfully!'
            };

            this.$store.commit(
              'setGlobalAlert',
              alert
            )
            this.$router.replace('/system-config/products/' + this.$route.params.product + '/insurers/')

        }).catch(error => {

            // Unauthorised
            if (error.response.status === 401) {
              this.$store.dispatch('logout');
            }

            if (error.response.status === 400) {

              window.scrollTo(document.querySelector('#error').offsetTop, 100);
              this.error = true;
              this.error_heading = 'There are errors on the form';
              this.error_text = 'Please fix the errors and re-submit the form';

              if (error.response.data) {

                //this.server_errors = error.response.data

                for (var key in error.response.data){

                  this.server_errors[key] = error.response.data[key][0]
                }
                this.$v.$reset();
                this.$v.$touch();

              }

            }

            console.log('premium error');
            console.log(error.response)
          });

        }
      }
    },
    mounted() {
      this.getInsurer()
      this.$v.details.$reset();
      this.$v.$reset()
    }
  }
</script>

<style>

  #data .card-header {
    padding-top: 1.5rem;
  }
</style>
